import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { FeedbackModel } from "./feedback-data-model";

export class FeedbackGridModel extends FeedbackModel { }

export class FeedbackListingModel extends GridModel<FeedbackGridModel> { }
export class FeedbackGridPostParams extends GridPostParams { }